const endpoints = {
	addElementToProjectLine: '/project_lines/addElementToProjectLine',
	updateProjectLineInfo: '/project_lines/updateProjectLineInfo',
	getCompanyProjectLines: '/project_lines/getCompanyProjectLines',
	getProjectLineDocuments: '/project_lines/getProjectLineDocuments',
}
export {endpoints}